import { makeVar, ReactiveVar } from '@apollo/client/core';
import { SuccessfulPurchase } from './successful-purchase/successful-purchase.interface';

export const CheckoutState: ReactiveVar<CheckoutState> = makeVar(null);
export interface CheckoutState {
    itemImagePath: string;
    recipientName: string;
    recipientEmail: string;
    itemTotal: number;
    itemNote: string;
    senderName: string;
    senderEmail: string;
    giftCardDesignID: number;
    expirationDays: number;
}

export const SuccessfulPurchaseState: ReactiveVar<SuccessfulPurchase> = makeVar(
    null
);
